import { render, staticRenderFns } from "./PhotoUploaderForm.vue?vue&type=template&id=09366b83&"
import script from "./PhotoUploaderForm.vue?vue&type=script&lang=js&"
export * from "./PhotoUploaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/InputComponent/index.vue').default,TextareaComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/TextareaComponent/index.vue').default,InputComponentSite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/InputComponentSite/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default})
